import styled from "./Contact.module.css"
import {IoLogoInstagram,IoLogoLinkedin,IoLogoWhatsapp } from 'react-icons/io'
import { useState } from "react"
import emailjs from 'emailjs-com'
import { useTranslation } from 'react-i18next'
const Contact = () => {
   const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID
   const templateId= process.env.REACT_APP_EMAILJS_TEMPLATE_ID
   const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY
   const { t } = useTranslation()
   
  const [contactForm, setContactForm] = useState({
    email: "",
    name: "",
    message: ""
  })

  const handleSubmit = async (e) => {
    e.preventDefault()

    try {
      await emailjs.send(
      serviceId,
      templateId,
      contactForm,
      publicKey
      )
      alert('Thank you for your message')
      setContactForm({email:'', name:'', message:''})
    } catch (error) {
      alert('Failed to send message')
    }
  }
  return (
  <div className={styled.mainContainer}>
  <div className={styled.contactContainer}>
  <div className={styled.contactInfo}>
    <h2>{t("Contact.Heading")}</h2>
    <p>{t("Contact.Subheading")}</p>
    <p>
  <strong>{t("Contact.Our Email")}: </strong>
  <a className={styled.emailLink} href="mailto:sales@ardeanlanguages.com"> sales@ardeanlanguages.com</a>
</p>
    <div className={styled.socialMedia}>
      <a
        href="https://www.instagram.com/ardeanlanguages/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
      >
        <IoLogoInstagram />
      </a>
      <a
        href="https://wa.me/905521600852"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp +90 552 160 08 52"
      >
        <IoLogoWhatsapp />
      </a>
    </div>
  </div>

  <form onSubmit={handleSubmit} className={styled.contactForm}>
    <input value={contactForm.name} onChange={(e) => setContactForm({...contactForm, name: e.target.value})} required type="text" name="user_name" placeholder={t("Contact.Name")} />
    <input value={contactForm.email} type="email" name="user_email" placeholder={t("Contact.Email")} required onChange={(e) => setContactForm({...contactForm, email: e.target.value})}/>
    <textarea value={contactForm.message} name="message" maxLength="3000" placeholder={t("Contact.Message")} required onChange={(e) => setContactForm({...contactForm, message: e.target.value})} />
    <button type="submit">{t("Contact.Send")}</button>
  </form>
</div>

    </div>
  )
}

export default Contact